import { render, staticRenderFns } from "./BadgeComponent.vue?vue&type=template&id=8825f07a"
import script from "./BadgeComponent.vue?vue&type=script&lang=js"
export * from "./BadgeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports